// src/App.tsx
import React, { useCallback, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { routes } from "./app/route";
import "./Fonts.css";
import Layout from "./components/layout/Layout";
import ProtectedRoute from "./components/layout/ProtectedRoute";
import { useAuth } from "./context/AuthContext";
import { ensureValidSession } from "./services/cognito";

const App: React.FC = () => {
  const { signOutHandler } = useAuth();

  // const handleSignout = useCallback(async () => {
  //   await signOutHandler();
  //   window.location.href = "/login";
  // }, [signOutHandler]);

  // useEffect(() => {
  //   const interval = setInterval(
  //     async () => {
  //       try {
  //         const session = await ensureValidSession();
  //         if (!session) {
  //           await handleSignout();
  //         }
  //       } catch {
  //         await handleSignout();
  //       }
  //     },
  //     10 * 60 * 1000,
  //   ); // every 10 min

  //   return () => clearInterval(interval);
  // }, [handleSignout]);

  return (
    <Routes>
      {routes.map((r) => (
        <Route
          key={r.path}
          path={r.path}
          element={
            r.isPublic ? (
              r.element
            ) : (
              <ProtectedRoute>
                <Layout>{r.element}</Layout>
              </ProtectedRoute>
            )
          }
        />
      ))}
    </Routes>
  );
};

export default App;
